import axios from 'axios';
import ApiURLs from '@/ApiURLs';

class AdminService {
  updatePrivacyPolicy(id: number,policyHtml: string) {
    return axios.put(ApiURLs.updatePrivacyPolicy, { id: id, html: policyHtml });
  }

  getPrivacyPolicy(id: number) {
    return axios.get(ApiURLs.getPrivacyPolicy, { params: { id }});
  }

  getUsers() {
    return axios.get(ApiURLs.getUsers);
  }

  getChildrenOfProvider(userId: string) {
    return axios.get(ApiURLs.getChildrenOfProvider, { params: { userId }});
  }

  getBookingInfoProvider(userId: string) {
    return axios.get(ApiURLs.getBookingInfoProvider, { params: { userId }});
  }  

  getBookingInfoChild({ childId, providerId }: any) {
    return axios.get(ApiURLs.getBookingInfoChild, { params: { childId, providerId }});
  }  

  deleteUser(userId: string) {
    return axios.post(ApiURLs.deleteUser, null, { params: { userId }});
  }
}

export default new AdminService();